import { TenantViewModel } from '@ail/customers-api'
import { UserContext } from '../../auth/authContext'
import { useTranslation } from 'react-i18next'
import { PermissionsEnum } from '../../types/enums'

interface Props {
  tenant?: TenantViewModel
  user: UserContext
}
export default function UserRolesAndPermissions({ tenant, user }: Props) {
  const { t } = useTranslation('common')
  function hasPermission(p: PermissionsEnum) {
    return !!user?.permissions?.includes(p)
  }
  return (
    <div className="col-12 settings-section roles-and-permissions">
      <div className="roles">
        <div className="popTitle">
          <div>
            <i className="icon-roles" />
            {t('ROLES_AND_PRIVILEGES')}
          </div>
        </div>
        <ul className="priviList">
          {!tenant?.isSupplier && !user.isSupplier && user.isManager && (
            <li className="selected">
              <input checked className="hiddenInput" name="IsManager" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-manager"></i>
                {t('MANAGER')}
              </div>
            </li>
          )}

          {user.isGuest && (
            <li className="selected">
              <input checked className="hiddenInput" name="IsGuest" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-help"></i>
                {t('GUEST')}
              </div>
            </li>
          )}
          {tenant?.isCompany && (
            <li className="selected">
              <input disabled checked className="hiddenInput" name="isCustomer" type="checkbox" readOnly />
              <div className="priv">
                <i className="icon-customers"></i>
                {t('CUSTOMER')}
              </div>
            </li>
          )}
          {tenant?.isSupplier && (
            <li className="selected">
              <input disabled checked className="hiddenInput" name="isSupplier" type="checkbox" readOnly />
              <div className="priv">
                <i className="icon-supplier"></i>
                {t('SUPPLIER')}
              </div>
            </li>
          )}
          {hasPermission(PermissionsEnum.ReportsView) && (
            <li className="selected">
              <input checked className="hiddenInput" name="Permissions" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-report"></i>
                {t('VIEW_REPORTS')}
              </div>
            </li>
          )}
          {hasPermission(PermissionsEnum.RequestsApprove) && (
            <li className="selected">
              <input checked className="hiddenInput" name="Permissions" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-requests"></i>
                {t('APPROVE_REQUEST')}
              </div>
            </li>
          )}
          {hasPermission(PermissionsEnum.OrdersManage) && (
            <li className="selected">
              <input checked className="hiddenInput" name="Permissions" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-requests-man"></i>
                {t('MANAGE_REQUESTS')}
              </div>
            </li>
          )}
          {hasPermission(PermissionsEnum.DocumentsView) && (
            <li className="selected">
              <input checked className="hiddenInput" name="Permissions" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-doc-folder"></i>
                {t('VIEW_DOCUMENTS')}
              </div>
            </li>
          )}
          {hasPermission(PermissionsEnum.CostsView) && (
            <li className="selected">
              <input checked className="hiddenInput" name="Permissions" type="checkbox" readOnly disabled />
              <div className="priv">
                <i className="icon-cost"></i>
                {t('VIEW_COSTS')}
              </div>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}
